import { useMutation } from '@tanstack/react-query';
import { RECAPTCHA_TYPES } from 'config/constants';
import { useApi } from 'hooks';
import { GAHandler } from 'utils/GA';
var useLoginVas = function () {
    var apiFetch = useApi().apiFetch;
    var mutationFn = function (props) {
        var provider = props.provider, token = props.token;
        var url = "/auth/login/vas/".concat(provider);
        return apiFetch({
            url: url,
            method: 'POST',
            data: { token: token },
            captcha: {
                type: RECAPTCHA_TYPES.v3,
                action: 'login_web_vas',
            },
        }).then(function (res) { return res.data; });
    };
    return useMutation({
        mutationFn: mutationFn,
        onSuccess: function (_, variables) {
            GAHandler('login_vas', { provider: variables.provider });
        },
        onError: function (_, variables) {
            GAHandler('login_vas_error', { provider: variables.provider });
        },
    });
};
export default useLoginVas;
